import type { JSX } from "react";
import { useObservable } from "ecce-react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { useAuth } from "../../../services/services-context";
import { MasqueradeIcon } from "../../atoms/icons/masquerade-icon";
import { PanelDialog } from "../../molecules/dialog-panel";
import { MasqueradeForm } from "./masquerade-form";


export const MasqueradeDialog = (): JSX.Element => {
	const auth = useAuth();
	useObservable(auth, "masquerading");
	useObservable(auth.masqueradeController, "dialogOpen");
	useObservable(auth.masqueradeController, "loading");
	useObservable(auth.masqueradeController, "selectedPerson");

	const { t } = useTranslation();

	const formId = "masqueradeForm";

	return (
		<PanelDialog
			title={ t("admin:masquerade.masquerade") as string }
			innerClassName="pad"
			icon={ MasqueradeIcon }
			open={ auth.masqueradeController.dialogOpen }
			onClose={ auth.masqueradeController.closeDialog }
			loading={ auth.masqueradeController.loading }
			primaryAction={{
				labelKey: `admin:masquerade.${auth.masquerading ? "stopMasquerading" : "masquerade"}`,
				disabled: auth.masquerading ? false : !auth.masqueradeController.selectedPerson,
				submitFormId: !auth.masquerading ? formId : null,
				onClick: auth.masquerading ? auth.endMasquerade : null,
			}}
			dismissible
		>
			{ auth.masquerading && (
				<Typography>
					Masquerading as <strong>{ auth.activeUser.name }</strong>.
				</Typography>
			) }
			{ !auth.masquerading && (
				<MasqueradeForm
					id={ formId }
					disabled={ auth.masqueradeController.loading }
				/>
			) }
		</PanelDialog>
	);
};
